import { createSlice } from '@reduxjs/toolkit';

interface AuthState {
  auth_loading: boolean;
}

const initialState: AuthState = {
  auth_loading: false,
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAuthLoading: (state, action) => {
      state.auth_loading = action.payload;
    },
  },
});

export const { setAuthLoading } = authSlice.actions;

export default authSlice.reducer;
